import { sendUXSEvent, TUxfbAttributes } from '../utils/uxs/sendUXSEvent';

const DEFAULT_INTERVAL_MS = 500;
const DEFAULT_MAX_WAIT_MS = 10_000;

const sendUXSEventSafely = (name: string, attributes?: TUxfbAttributes): void => {
  try {
    sendUXSEvent(name, attributes);
  } catch {
    return;
  }
};

export interface ISendUXSEventWhenReadyOptions {
  intervalMs?: number;
  maxWaitMs?: number;
}

export const sendUXSEventWhenReady = (
  name: string,
  attributes?: TUxfbAttributes,
  options: ISendUXSEventWhenReadyOptions = {},
): void => {
  if (typeof window === 'undefined') {
    return;
  }

  if (window.UXS) {
    sendUXSEventSafely(name, attributes);

    return;
  }

  const intervalMs = options.intervalMs ?? DEFAULT_INTERVAL_MS;
  const maxWaitMs = options.maxWaitMs ?? DEFAULT_MAX_WAIT_MS;
  let waitedMs = 0;
  const intervalId = window.setInterval(() => {
    waitedMs += intervalMs;

    if (window.UXS) {
      window.clearInterval(intervalId);
      sendUXSEventSafely(name, attributes);

      return;
    }

    if (waitedMs >= maxWaitMs) {
      window.clearInterval(intervalId);
    }
  }, intervalMs);
};
